module.exports = __webpack_public_path__ + "static/img/photo14.06868692.jpg";